import React, { useEffect, useState, useRef } from 'react';
import { ShoppingProcessType } from "InitialData/constant";
import Dummy from "components/Dummy";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import style from "./VendingLayout.module.css";
import addCart from "resources/img/puffu/cartWhite.png";
import order from "resources/img/puffu/coin.png";
import box from "resources/img/puffu/box.png";
import Inline from 'layouts/container/Inline';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { requester } from 'App';
import CategoryTab from './process/category/CategoryTab';
import Center from 'layouts/wrapper/Center';
import { useSelector, useDispatch } from 'react-redux';
import CartList from './process/cart/CartList';
import { CartReducer } from 'shared/redux/reducers/shopping/CartReducer';
import CartResetModal from './process/cart/CartResetModal';
import { toast } from 'react-toastify';
import listIcon from "resources/img/puffu/list.png";
import detailIcon from "resources/img/puffu/detail.png";
import reviewIcon from "resources/img/puffu/review.png";
import VendingProductDetail from './process/product/VendingProductDetail';
import VendingProductReview from './process/product/VendingProductReview';
import VendingProductInfo from './process/product/VendingProductInfo';
import rightIcon from "resources/img/puffu/right.png";
import leftIcon from "resources/img/puffu/left.png";
import closeIcon from "resources/img/puffu/close.png";
import mainIcon from 'resources/img/puffu/mainIcon.png';
import homeBtnIcon from "resources/img/puffu/homebtn.svg";
import VendingProductLayout from './process/product/VendingProductLayout';
import MainView from './process/MainView';
import { CategoryProvider } from './process/category/CategoryContext';
import { resetSortingState, closeDropdown } from './process/category/SortingDropdownReducer';
import { useTouchClick } from "shared/hooks/useTouchClick";
import { setSelectedSubCategoryId, resetCategoryState } from './process/category/CategoryReducer';
import categorySound from "resources/music/물방울.mp3";
import signUpSound from "resources/music/audio_0_안녕하세요___빠르고_간편한_무인매장_푸푸입니다.mp3";
import btnSound from "resources/music/button-pressed-38129.mp3";
import { HistoryReducer } from 'shared/redux/reducers/history/HistoryReducer';


function VendingLayout() {
    const { id } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedSubCategoryId } = useSelector((state) => state.category);
    const poplocation = window.location.pathname.split('/').pop();
    const cartData = useSelector((state) => state.cart.products);
    const { currentSortOption, sortingOptions } = useSelector((state) => state.sortingDropdown);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [cartList, setCartList] = useState([]);
    const [total, setTotal] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState('main');
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1); // 페이지 상태 추가
    const [currentTab, setCurrentTab] = useState('info'); // 현재 탭 상태 추가
    const [isModalOpen, setIsModalOpen] = useState(false); // 모달 상태 추가
    const [rankedProducts, setRankedProducts] = useState([]);
    const [showButtons, setShowButtons] = useState(true); // MainView의 버튼 표시 여부
    const audioRef = useRef();
    const audio1Ref = useRef();
    const audio2Ref = useRef();
    const [pagingData, setPagingData] = useState({
        totalElements: 0,
        currentPage: 0,
        hasNext: false,
        hasPrevious: false
    });

    const [viewData, setViewData] = useState({
        title: "",
        footterButtonText: "",
        currentProcess: ShoppingProcessType.CART,
        totalCount: 0,
        selectedCount: 0,
        priceSum: 0,
        vat: 0,
        deliveryFee: 0,
        discountSum: 0,
        totalAmount: 0,
        onDeleteSelectedProductsClick: () => { },
        onSubmitButtonClick: () => { },
        detailYn: false,
        detailProduct: null,
        view: null,
        reviewCount: 0,
        slideGuide: true
    });

    const isPaymentRoute = location.pathname.includes('payment');
    const isReceiveRoute = location.pathname.includes('receiveItem');


    const shoppingProcesses = [
        { orderNo: ShoppingProcessType.CART, title: t("상품담기"), icon: addCart, size: "25px" },
        { orderNo: ShoppingProcessType.ORDER, title: t("결제하기"), icon: order, size: "30px" },
        { orderNo: ShoppingProcessType.ORDER_COMPLETE, title: t("상품수령"), icon: box, size: "25px" },
    ];

    const categoriesDetail = [
        { id: "info", categoryName: "기본정보", categoryImage: listIcon },
        { id: "detail", categoryName: "상세페이지", categoryImage: detailIcon },
        { id: "review", categoryName: "사용후기", categoryImage: reviewIcon }
    ];

    const handleCategoryClick = (category) => {
        audio1Ref.current.play();
        if (category === 'all') {
            setCurrentPage(1);
            onCloseClick(category);
            fetchProductData(category, 0);
            setSelectedCategory(category);
            navigate(`/ws/${id}/main`)
        } else if (category === 'main') {
            setCurrentPage(1);
            onCloseClick(category);
            setShowButtons(true);
            setFilteredProducts(products);
            dispatch(resetCategoryState());
            setSelectedCategory(category);
            navigate(`/ws/${id}/main`)
        } else {
            if (selectedCategory === category) {
                onCloseClick(category);
                navigate(`/ws/${id}/main`)
            } else {
                setCurrentPage(1);
                onCloseClick(category);
                dispatch(resetCategoryState());
                setSelectedCategory(category);
                navigate(`/ws/${id}/main`)
            }
        }
    };

    const onCartRemoveAllClick = () => {
        audio1Ref.current.play();
        setIsModalOpen(true); // 모달 열기
    };

    const onConfirm = () => {
        audio1Ref.current.play();
        dispatch(CartReducer.actions.reset());
        setIsModalOpen(false); // 모달 닫기
    };

    const onCancel = () => {
        setIsModalOpen(false); // 모달 닫기
    };

    const handleTabChange = (direction) => {
        audio1Ref.current.play();
        const tabOrder = ['info', 'detail', 'review'];
        const currentIndex = tabOrder.indexOf(currentTab);
        const newIndex = direction === 'prev'
            ? (currentIndex > 0 ? currentIndex - 1 : tabOrder.length - 1)
            : (currentIndex < tabOrder.length - 1 ? currentIndex + 1 : 0);

        setCurrentTab(tabOrder[newIndex]);
    };

    const onCloseClick = (category) => {
        audio1Ref.current.play();
        setViewData((prevData) => ({
            ...prevData,
            detailYn: false,
            detailProduct: null,
            currentProcess: ShoppingProcessType.CART

        }));
        setCurrentTab('info')
    }

    const onHomeBtnClick = () => {
        audio1Ref.current.play();
        dispatch(CartReducer.actions.reset());
        navigate(`/ws/${id}/home`)
    }

    const onTestPaymentModalClick = () => {
        audio2Ref.current.play();
        if (cartData.length > 0) {
            // NiceModal.show("testPayment", { id: id, onClose: paymentModalCallback, userName: "" });
            setViewData((prevData) => ({
                ...prevData,
                detailYn: false,
                detailProduct: null
            }));;
            setShowButtons(false);
            // setSelectedCategory('');
            navigate(`/ws/${id}/main/payment`, { state: { category: selectedCategory } })
        } else {
            toast.error(`먼저 상품을 담아주세요.`, {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
        }
    }

    const renderTabContent = () => {
        audio1Ref.current.play();
        switch (currentTab) {
            case 'info':
                return <VendingProductInfo data={viewData.detailProduct} currentTab={currentTab}
                    setCurrentTab={setCurrentTab} />;
            case 'detail':
                return <VendingProductDetail data={viewData.detailProduct} currentTab={currentTab}
                    setCurrentTab={setCurrentTab} />;
            case 'review':
                return <VendingProductReview data={viewData.detailProduct} currentTab={currentTab}
                    setCurrentTab={setCurrentTab} />;
            default:
                return null;
        }
    };



    // 페이지 변경 핸들러
    const handlePageChange = (direction, page) => {
        audio2Ref.current.play();
        let newPage = direction === 'goto' ? page : pagingData.currentPage + (direction === 'next' ? 1 : -1);
        fetchProductData(selectedSubCategoryId ? selectedSubCategoryId : selectedCategory, newPage); // currentSortOption을 유지하며 요청합니다.
        dispatch(closeDropdown());
    };


    // 데이터 요청 함수
    const fetchProductData = (category, page = 0, sortOption = currentSortOption) => {
        if (category === 'main') return;

        // 로딩 시작
        dispatch(HistoryReducer.actions.setLoading(true));

        // 정렬 옵션 설정
        let sortBy = 'product.salesVolume';
        let sortDirection = 'DESC';

        switch (sortOption) {
            case '신제품순':
                sortBy = 'id';
                sortDirection = 'DESC';
                break;
            case '가격 낮은 순':
                sortBy = 'product.price';
                sortDirection = 'ASC';
                break;
            case '가격 높은 순':
                sortBy = 'product.price';
                sortDirection = 'DESC';
                break;
            case '리뷰 많은 순':
                sortBy = 'product.salesVolume';
                sortDirection = 'DESC';
                break;
        }

        // Redux에서 서브카테고리 선택 상태 가져오기
        const isCategoryInSubCategories = subCategories.some(sc => sc.id === category);

        const categoryIds = isCategoryInSubCategories
            ? [category] // category가 subCategories에 포함되면 그대로 사용
            : subCategories
                .filter(sc => sc.parentCategoryId === category)
                .map(sc => sc.id); // 포함되지 않으면 해당 category의 자식 ID 목록 사용

        const requestData = {
            storeCode: id,
            categoryIds,
            page,
            size: 10,
            sortBy,
            sortDirection
        };

        requester.findAllVendorProductsByCategory(requestData, (result) => {
            if (result.data) {
                setFilteredProducts(result.data.content);
                setPagingData({
                    totalPages: result.data.totalPages,
                    totalElements: result.data.totalElements,
                    currentPage: result.data.currentPage,
                    hasNext: result.data.hasNext,
                    hasPrevious: result.data.hasPrevious
                });
            } else {
                console.error('Failed to fetch products:');
            }
            dispatch(HistoryReducer.actions.setLoading(false));
        });
    };
    const handleSlide = (deltaX, deltaY) => {
        const direction = deltaX > 0 ? 'next' : 'prev';
        handleTabChange(direction);
    };

    const { handleTouchStart, handleTouchEnd } = useTouchClick(
        () => { }, // 클릭 콜백은 필요 없음
        100,      // 슬라이드 감지 임계값
        handleSlide
    );
    const { handleTouchStart: homeBtnTouchStart, handleTouchEnd: homeBtnTouchEnd } = useTouchClick(onHomeBtnClick, 50);
    const { handleTouchStart: mainCategoryTouchStart, handleTouchEnd: mainCategoryTouchEnd } = useTouchClick(() => handleCategoryClick('main'), 50);
    const { handleTouchStart: allCategoryTouchStart, handleTouchEnd: allCategoryTouchEnd } = useTouchClick(() => handleCategoryClick('all'), 50);
    const { handleTouchStart: paymentModalTouchStart, handleTouchEnd: paymentModalTouchEnd } = useTouchClick(onTestPaymentModalClick, 50);


    useEffect(() => {
        if (cartData) {
            setCartList(cartData);
        }
        const newTotal = cartData.reduce((acc, item) => acc + item.quantity * item.price, 0);
        setTotal(newTotal);
    }, [cartData]);

    useEffect(() => {

        let data = { storeCode: id }
        requester.openfindAllCategory((result) => {
            const filteredCategories = result.data.filter(category => category.parentCategoryId == null);
            const filteredSubCategories = result.data.filter(category => category.parentCategoryId != null);
            setCategories(filteredCategories);
            setSubCategories(filteredSubCategories);
        });

    }, []);

    useEffect(() => {
        // selectedCategory가 변경될 때마다 SortingDropdown 상태 초기화
        dispatch(resetSortingState());
        dispatch(closeDropdown());
    }, [selectedCategory]);

    useEffect(() => {
        dispatch(closeDropdown());
    }, [viewData.detailYn])

    // 카테고리 변경 시 데이터 로드
    useEffect(() => {

        fetchProductData(selectedCategory);
    }, [selectedCategory]);


    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.play().catch((error) => {
                console.error('오디오 재생 오류:', error);
            });
        }
        dispatch(HistoryReducer.actions.setLoading(true));
    }, [])
    useEffect(() => {
        if (location.state && location.state.category === 'main') {

            if (filteredProducts.length > 0) {

            } else {
                // setSelectedCategory('');
                setSelectedCategory('main');
                setShowButtons(true);
            }
        }
    }, [location]);


    return (
        <div style={{ position: "relative", height: "100%" }}>
            <audio ref={audioRef} src={signUpSound} preload="auto" />
            <audio ref={audio1Ref} src={categorySound} preload="auto" />
            <audio ref={audio2Ref} src={btnSound} preload="auto" />
            <Dummy height={"10vh"} />
            <HorizontalFlex flexStart>
                <FlexChild justifyContent={"flex-start"}>
                    <VerticalFlex >
                        <FlexChild alignItems={"flex-start"}>
                            <VerticalFlex>
                                <FlexChild>
                                    <div className={style.categoryArea}>
                                        <div
                                            style={{
                                                width: "25%",
                                                border: "1px solid var(--main-color)",
                                                borderRadius: "0",
                                                backgroundColor: selectedCategory === 'main' ? "var(--point-color)" : "white",
                                            }}
                                            className={style.filterCategoryBtn}
                                            onPointerDown={mainCategoryTouchStart}
                                            onPointerUp={mainCategoryTouchEnd}
                                        >
                                            <div className={style.allBtn}>
                                                <Center>
                                                    <Dummy height={"10px"} />
                                                    <div style={{ height: "45px" }}>
                                                        {/* <MainIcon style={{ fill: 'white', width: "45px" }} /> */}
                                                        <img src={mainIcon} width={"55px"} style={{ filter: selectedCategory === 'main' ? "invert(50%) brightness(10000%)" : null }} />
                                                    </div>
                                                    <Dummy height={"20px"} />
                                                    <P color={selectedCategory === 'main' ? "white" : "var(--point-color)"} weight={700} font={"Pretendard"} size={"1.6vw"}>메인</P>
                                                </Center>
                                            </div>
                                        </div>
                                        {categories && categories.map((data, index) => (
                                            <div
                                                key={data.id}
                                                className={`${style.filterCategoryBtn} ${selectedCategory === data.id ? style.selectedCategory : ''}`}
                                                // onPointerDown={() => handleCategoryClick(data.id)}
                                                style={{ width: "25%", display: "flex", flexDirection: "column", justifyContent: "center" }}
                                            >   <CategoryProvider>
                                                    <CategoryTab
                                                        key={data.id}
                                                        data={data}
                                                        onCategoryClick={handleCategoryClick}
                                                        selectedCategory={selectedCategory}
                                                    />
                                                </CategoryProvider>
                                            </div>

                                        ))}
                                    </div>
                                </FlexChild>
                                <FlexChild alignItems={"flex-start"}>
                                    <HorizontalFlex flexStart>
                                        <FlexChild width={"75%"}>
                                            {
                                                selectedCategory === 'main' 
                                                    && !isPaymentRoute 
                                                    && !isReceiveRoute
                                                    &&
                                                    !viewData.detailYn
                                                    ?
                                                    <MainView
                                                        showButtons={showButtons}
                                                        setShowButtons={setShowButtons}
                                                        currentPage={currentPage}
                                                        setCurrentPage={setCurrentPage}
                                                        products={products}
                                                        filteredProducts={filteredProducts}
                                                        setFilteredProducts={setFilteredProducts}
                                                        setSelectedCategory={setSelectedCategory}
                                                        selectedCategory={selectedCategory}
                                                        rankedProducts={rankedProducts}
                                                        setViewData={setViewData}
                                                        viewData={viewData}
                                                    />
                                                    : viewData.detailYn ? (
                                                        <HorizontalFlex flexStart>
                                                            <FlexChild width={"825px"}>
                                                                <div
                                                                    onPointerDown={handleTouchStart}
                                                                    onPointerUp={handleTouchEnd}
                                                                    style={{ width: "100%", height: "100%", position: "relative", justifyContent: "center", display: "flex" }}
                                                                >
                                                                    <div style={{ position: "absolute", top: '100px', width: "max-content", left: "89%" }} onPointerUp={() => onCloseClick(selectedCategory)}>
                                                                        <img src={closeIcon} width={"30px"} style={{ filter: "invert(60%)", position: "relative", right: 0 }} />
                                                                    </div>
                                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', bottom: '-3.4vh', width: '93%', zIndex: 9999 }}>
                                                                        <div
                                                                            onPointerDown={() => handleTabChange('prev')}
                                                                            style={{
                                                                                width: "600px",
                                                                                height: "44px",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                backgroundColor: currentTab === 'info' ? "white" : "rgba(255, 121, 25, 1)",
                                                                                border: currentTab === 'info' ? "1.5px solid rgba(255, 121, 25, 1)" : "white",
                                                                                color: "#fff",
                                                                                cursor: currentTab === 'info' ? null : "pointer",
                                                                                borderRadius: '5px',
                                                                                padding: "0 10px"
                                                                            }}
                                                                            className={style.btn}
                                                                        >
                                                                            <HorizontalFlex>
                                                                                <FlexChild width={"40%"}>
                                                                                    <img src={leftIcon} width={"10px"} style={{ filter: currentTab !== 'info' && "invert(50%) brightness(250%)" }} />
                                                                                </FlexChild>
                                                                                <FlexChild>
                                                                                    <P font={"Pretendard"} weight={700} size={20} color={currentTab === 'info' ? "rgba(255, 121, 25, 1)" : "white"}>이전</P>
                                                                                </FlexChild>
                                                                            </HorizontalFlex>
                                                                        </div>
                                                                        <div style={{ display: "flex", flexDirection: "row", gap: "10px", justifyContent: "center" }}>
                                                                            {Array.from({ length: 3 }).map((_, index) => (
                                                                                <div
                                                                                    key={index}
                                                                                    style={{
                                                                                        width: '10px',
                                                                                        height: '10px',
                                                                                        borderRadius: '50%',
                                                                                        backgroundColor: currentTab === categoriesDetail[index].id ? 'var(--main-color)' : 'white',
                                                                                        border: currentTab === categoriesDetail[index].id ? "none" : "1px solid black",
                                                                                        margin: '0 5px',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                    onClick={() => setCurrentTab(categoriesDetail[index].id)}
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                        <div
                                                                            onPointerDown={() => handleTabChange('next')}
                                                                            style={{
                                                                                width: "600px",
                                                                                height: "44px",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                backgroundColor: currentTab === 'review' ? "white" : "rgba(255, 121, 25, 1)",
                                                                                border: currentTab === 'review' ? "1.5px solid rgba(255, 121, 25, 1)" : "white",
                                                                                color: "#fff",
                                                                                cursor: currentTab === 'review' ? null : "pointer",
                                                                                borderRadius: '5px',
                                                                                padding: "0 10px"
                                                                            }}
                                                                            className={style.btn}
                                                                        >
                                                                            <HorizontalFlex>
                                                                                <FlexChild justifyContent={"flex-end"}>
                                                                                    <P font={"Pretendard"} weight={700} size={20} color={currentTab === 'review' ? "rgba(255, 121, 25, 1)" : "white"}>다음</P>
                                                                                </FlexChild>
                                                                                <FlexChild width={"40%"} justifyContent={"flex-end"}>
                                                                                    <img src={rightIcon} width={"10px"} style={{ filter: currentTab !== 'review' && "invert(50%) brightness(250%)" }} />
                                                                                </FlexChild>
                                                                            </HorizontalFlex>
                                                                        </div>
                                                                    </div>
                                                                    <FlexChild>
                                                                        <VerticalFlex>
                                                                            <FlexChild height={"max-content"}>
                                                                                <Dummy height={"65px"} />
                                                                            </FlexChild>
                                                                            <FlexChild width={"93%"}>
                                                                                <VendingProductLayout
                                                                                    data={viewData.detailProduct}
                                                                                    currentTab={currentTab}
                                                                                    setCurrentTab={setCurrentTab}
                                                                                    view={viewData.view}
                                                                                    count={viewData.reviewCount}
                                                                                >
                                                                                    {renderTabContent()}
                                                                                </VendingProductLayout>
                                                                            </FlexChild>
                                                                        </VerticalFlex>
                                                                    </FlexChild>
                                                                </div>
                                                            </FlexChild>
                                                        </HorizontalFlex>
                                                    ) :
                                                        <Outlet context={{
                                                            fetchProductData,
                                                            setViewData,
                                                            filteredProducts,
                                                            currentPage,
                                                            setCurrentPage,
                                                            selectedCategory,
                                                            subCategories,
                                                            pagingData,
                                                            onPageChange: handlePageChange
                                                        }} />
                                            }
                                        </FlexChild>
                                        <FlexChild>
                                            <div style={{ width: "270px", height: "80vh", backgroundColor: "var(--main-color)", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <Dummy height={"10px"} />

                                                <Dummy height={"16px"} />
                                                <P color={"white"} weight={700} font={"Pretendard"} size={"2.8vw"}>장바구니</P>
                                                <Dummy height={"16px"} />
                                                <CartList />
                                                <Dummy height={"20px"} />
                                                <div className={style.refreshButton} onPointerDown={paymentModalTouchStart} onPointerUp={paymentModalTouchEnd}>
                                                    <Center>
                                                        <P font={"Pretendard"} color={"var(--main-color)"} weight={700} size={"2.3vw"}>총 {total.toLocaleString()}원</P>
                                                        <P font={"Pretendard"} color={"black"} weight={700} size={"2.3vw"}>결제하기</P>
                                                    </Center>
                                                </div>
                                                <Dummy height={"20px"} />
                                                <div className={style.cartRemoveAllBtn} onClick={onCartRemoveAllClick}>
                                                    <Center>
                                                        <P size={"2.3vw"} weight={700}>전체 취소</P>
                                                    </Center>
                                                </div>
                                                <Dummy height={"20px"} />
                                                <div className={style.homeBtn} onPointerDown={homeBtnTouchStart} onPointerUp={homeBtnTouchEnd} style={{ backgroundColor: "white" }}>
                                                    <Center>
                                                        <Inline>
                                                            <img src={homeBtnIcon} width={"35px"} />
                                                            <Dummy width={"15px"} />
                                                            <P color={"var(--main-color)"} weight={900} font={"Pretendard"} size={"2.3vw"}>처음으로</P>
                                                        </Inline>
                                                    </Center>
                                                </div>
                                            </div>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </HorizontalFlex>
            <div className={style.paymentProcessArea}>
                <div className={style.paymentProcessWrap}>
                    {shoppingProcesses.map((row, index) => (
                        viewData.currentProcess === row.orderNo ? (
                            row.orderNo === 1 ? (
                                <>
                                    <div style={{ position: "absolute", zIndex: 1, left: 0, bottom: 0, backgroundColor: "var(--point-color)", width: "30px", height: "100%" }}></div>
                                    <div className={style.processItemArea} key={index}>
                                        <Inline>
                                            <img width={row.size} src={row.icon} alt={row.title} />
                                            <P font={"Pretendard"} size={24} weight={700} color={"white"}> {row.title}</P>
                                        </Inline>
                                    </div>
                                    <div className={style.firstAngle}></div>
                                </>
                            ) : row.orderNo === 3 ? (
                                <>
                                    <div style={{ position: "absolute", zIndex: 1, right: "-30px", bottom: 0, backgroundColor: "var(--point-color)", width: "30px", height: "100%" }}>1</div>
                                    <div className={style.processItemArea} key={index}>
                                        <Inline>
                                            <img width={row.size} src={row.icon} alt={row.title} />
                                            <P font={"Pretendard"} size={24} weight={700} color={"white"}> {row.title}</P>
                                        </Inline>
                                    </div>
                                    <div className={style.lastAngle}></div>
                                </>
                            ) : (
                                <div className={style.processItemArea} key={index}>
                                    <Inline>
                                        <img width={row.size} src={row.icon} alt={row.title} />
                                        <P font={"Pretendard"} size={24} weight={700} color={"white"}> {row.title}</P>
                                    </Inline>
                                </div>
                            )
                        ) : (
                            <div className={`${style.baseProcessItemArea} ${index !== shoppingProcesses.length - 1 ? style.withBorder : ''}`} key={index}>
                                <Inline>
                                    <img width={row.size} src={row.icon} alt={row.title} style={{ filter: "invert(40%)" }} />
                                    <P font={"Pretendard"} color={"rgba(0,0,0,0.5)"} size={24} weight={700}> {row.title}</P>
                                </Inline>
                            </div>
                        )
                    ))}
                </div>
            </div>
            <CartResetModal
                isOpen={isModalOpen}
                onRequestClose={onCancel}
                onConfirm={onConfirm}
                onCancel={onCancel}
                message={t("해당 주문상품을 삭제하시겠습니까 ?")}
            />
        </div>
    );
}

export default VendingLayout;